import { writable, get } from "svelte/store";
/**
 * On init, Firebase Auth will load user to determine if there is user
 * has been logged in. It's used as a flag to determine the loading process
 * is done or not.
 */
export const isCurrentUserLoaded = writable(false);
/** Indicate whether the init auth is done or not */
export const initAuthProcess = writable(false);
/**
 * Indicate whether user has been logged in or not
 */
export const isLoggedIn = writable(null);
export const currentUserStore = writable(null);
export function setCurrentUser(user) {
    currentUserStore.set(user);
    if (!get(isCurrentUserLoaded)) {
        isCurrentUserLoaded.set(true);
    }
    isLoggedIn.set(user && !user.isAnonymous);
}
export const userInfoStore = writable(null);
export async function setUserInfo(info) {
    userInfoStore.set(info);
}
